import { withStyles } from "@material-ui/core";
import React from "react";

const PendencyListHeader = ({
  classes,
  t,
}) => {
  return (<div>
    <h1 className={classes.title}>{t("pendency:pendencies")}</h1>
    <p className={classes.description}>{t("pendency:pendency-text")}</p>
  </div>)
}

const styles = (theme) => ({
  title: {
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 24,
  },
  description: {
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.default1.light,
  }
})

export default withStyles(styles)(PendencyListHeader);
